import {
  ASTON_VK_LINK,
  RADIO_TG_LINK,
  ASTON_YOUTUBE_LINK,
  ASTON_INSTAGRAM_LINK,
} from 'constants/global';

import commonAssets from 'assets/common';
import Case from 'assets/icons/case.svg';
import tg_red from 'assets/icons/tg_red.svg';
import vk_red from 'assets/icons/vk_red.svg';
import vk_green from 'assets/icons/vk_green.svg';
import inst_red from 'assets/icons/inst_red.svg';
import tg_green from 'assets/icons/tg_green.svg';
import inst_green from 'assets/icons/inst_green.svg';
import youtube_red from 'assets/icons/youtube_red.svg';
import youtube_green from 'assets/icons/youtube_green.svg';

export const socialMedias = [
  {
    href: RADIO_TG_LINK,
    src: tg_green,
    alt: 'tg',
  },
  {
    href: ASTON_INSTAGRAM_LINK,
    src: inst_green,
    alt: 'inst',
    isBlocked: true,
  },
  {
    href: ASTON_YOUTUBE_LINK,
    src: youtube_green,
    alt: 'youtube',
  },
  {
    href: ASTON_VK_LINK,
    src: vk_green,
    alt: 'vk',
  },
];

export const culturalCodeSocialMedias = [
  {
    href: RADIO_TG_LINK,
    src: tg_red,
    alt: 'tg',
  },
  {
    href: ASTON_INSTAGRAM_LINK,
    src: inst_red,
    alt: 'inst',
    isBlocked: true,
  },
  {
    href: ASTON_YOUTUBE_LINK,
    src: youtube_red,
    alt: 'youtube',
  },
  {
    href: ASTON_VK_LINK,
    src: vk_red,
    alt: 'vk',
  },
];

export const offices = [
  {
    city: 'г. Москва',
    address: `ул. Вильгельма Пика, 11 <br/>
    БЦ «Ботаника», 13 эт., оф. 1310 <br/>
    Россия`,
  },
  {
    city: 'г. Санкт-Петербург',
    address: `Владимирский пр-т, 23 <br />
    БЦ «ICON», 8 эт. <br/>
    Россия`,
  },
  {
    city: 'г. Казань',
    address: `ул. Н. Ершова, 76/1, оф. 219 <br/>
    Россия`,
  },
  {
    city: 'г. Минск',
    address: `пр-т Победителей, 7А, <br/>
    БЦ «Royal Plaza», 23 и 25 эт. <br/>
    Беларусь`,
  },
  {
    city: 'г. Витебск',
    address: `Московский пр-т, 70к1 <br/>
    Беларусь`,
  },
  {
    city: 'г. Полоцк',
    address: `ул. Октябрьская, 25 <br/>
    Беларусь`,
  },

  {
    city: 'г. Гомель',
    address: `ул. Советская, 41Б <br/>
    Беларусь`,
  },
];

export const infoLinks = [
  {
    type: 'Телефон',
    icon: commonAssets.phone,
    text: '+7 (495) 138 39 39',
    linkTitle: 'Позвонить по номеру телефона',
    link: 'tel: +74951383939',
  },
  {
    type: 'Почта',
    icon: commonAssets.mail,
    text: 'info@astondevs.ru',
    linkTitle: 'Написать письмо на почту',
    link: 'mailto: info@astondevs.ru',
  },
  {
    type: 'Реквизиты',
    icon: Case,
    text: 'Реквизиты компании',
    linkTitle: 'Перейти на страница с реквизитами',
    link: '/details',
    linkProps: { isExternal: true },
  },
];
